module.exports = __webpack_public_path__ + "static/img/banner bgi.ef107efe.jpg";